<div class="flex flex-col-reverse full-width bg-surface lg:bg-transparent -mt-2">
  <soft-step-header [steps]="steps" [currentIndex]="1" #stepper></soft-step-header>
  <soft-default-header
    [overline]="stepper.stepText"
    [title]="stepper.current()?.header | translate"
    [subtitle]="stepper.current()?.subHeader | translate"
  ></soft-default-header>
</div>

@if(quellLagerplatz$ | async; as quellLagerplatz) {
<soft-scan-button class="mt-4"></soft-scan-button>
@if (quellLagerplatz.inhalt?.length) {
<div class="soft-overline mt-4">
  {{'#LAGERPLATZ_UMLAGERUNG.PAGES.ARTIKEL_AUSWAHL.ARTIKEL' | translate}}
</div>
<soft-artikel-menge-auswahl
  [lagerplatzInhalt]="(quellLagerplatz$ | async)?.inhalt"
  (artikelMengeChange)="onSelect($event)"
></soft-artikel-menge-auswahl>
} @if (quellLagerplatz.mischpaletten?.length) {
<div class="soft-overline mt-4">
  {{'#LAGERPLATZ_UMLAGERUNG.PAGES.ARTIKEL_AUSWAHL.MISCHPALETTEN' | translate}}
</div>

    <div class="flex flex-col gap-2">
      @for (mixedPallet of quellLagerplatz.mischpaletten; track mixedPallet.id) {
        <div
          class="flex flex-row gap-2 soft-card hover:bg-hover cursor-pointer"
          (click)="onSelectMischpalette(mixedPallet)"
          >
          <soft-mixed-pallet
            class="w-full"
            [pallet]="mixedPallet.palette"
            [stockyard]="mixedPallet.lagerplatz"
            [items]="mixedPallet.artikel"
          ></soft-mixed-pallet>
          <div class="flex flex-col justify-center items-center">
            <i class="fa-regular fa-chevron-right color-light"></i>
          </div>
        </div>
      }
    </div>
    } }

    @if (loading$ | async) {
      <soft-blocking-loading-spinner
        class="top-0 right-0"
      ></soft-blocking-loading-spinner>
    }
